<template>
  <div>
    <h1>
      <div class="font-weight-medium article-header-title headline-4">
        <span
          v-if="isRetracted"
          class="font-weight-medium"
          :class="{
            'article-header-title--retracted': newArticleDetailsDisplay,
          }"
        >
          RETRACTED:
        </span>
        <ArticleTitle :article-html-title="article.title" />
      </div>
    </h1>
    <div class="my-4">
      <span class="font-weight-medium">{{
        `${localPublishedDate}, Version ${article.version}`
      }}</span>
    </div>
    <div>
      <v-alert
        v-if="!isLatestVersion"
        class="elevation-0 theme--dark"
        color="warning"
      >
        <div class="subtitle-1">
          <span>This is not the most recent version. There is a</span>
          <nuxt-link
            :to="`/engage/${partner}/article-details/${latestVersionId}`"
            ><div class="underline d-inline-block font-weight-bold has-action">
              newer version
            </div></nuxt-link
          >
          <span>of this content available</span>
        </div>
      </v-alert>
      <div v-if="isBlocked" class="mt-3">
        <v-alert class="elevation-0 theme--dark" color="warning"
          >This content has been removed</v-alert
        >
      </div>
      <div v-else-if="isRetracted && !newArticleDetailsDisplay" class="mt-3">
        <v-alert class="elevation-0 theme--dark" color="warning"
          >This content has been retracted</v-alert
        >
        <h2 class="title">Retraction Notice</h2>
        <div class="subtitle-1">
          {{ article.retraction.response.message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import mapFlags from "~/plugins/utilities/mapFlags";

import sorted from "~/plugins/utilities/sorted.js";
import localDateTime from "~/plugins/utilities/localDateTime";

import ArticleTitle from "~/components/articles/components/ArticleTitle.vue";

export default {
  name: "ArticleHeaderTitle",
  components: {
    ArticleTitle,
  },
  props: {
    article: { type: Object, required: true },
  },
  computed: {
    ...mapState({
      isBlocked: (state) => state.selectedItem.blocked,
    }),
    ...mapFlags(["newArticleDetailsDisplay"]),
    partner() {
      return this.$config.partner;
    },
    latestVersionId() {
      const { versionHistory } = this.article;

      if (!versionHistory) {
        return true;
      }

      const history = versionHistory.map((versionRef) => {
        const version = parseInt(versionRef.version, 10);

        return { ...versionRef, version };
      });

      const latestVersion = sorted(history, "version").reverse()[0];

      return latestVersion ? latestVersion.itemId : this.article.id;
    },
    isLatestVersion() {
      return this.article.id === this.latestVersionId;
    },
    isRetracted() {
      const { retraction } = this.article;

      return (
        retraction &&
        retraction.response &&
        retraction.response.retractionStatus === "ACCEPTED"
      );
    },
    localPublishedDate() {
      return localDateTime(this.article.publishedDate, "dd LLLL yyyy");
    },
  },
};
</script>

<style lang="scss" scoped>
.article-header-title {
  line-height: 40px;

  &--retracted {
    color: #804400;
  }
}
</style>
